module.exports = __webpack_public_path__ + "img/circle-plus.c73b35fb.svg";